import { EProgramTypes } from '@ucheba/utils/types/program'
import { ProgramTypeChilds } from './constants'

export const getProgramTypeWithChilds = (type: EProgramTypes): EProgramTypes[] => {
  const result: EProgramTypes[] = [type]
  if (type in ProgramTypeChilds) {
    result.push(...ProgramTypeChilds[type])
  }
  return result
}
